__turbopack_context__.v({
  "caption": "StoryViewer-module-scss-module__D02-Pq__caption",
  "caption-body": "StoryViewer-module-scss-module__D02-Pq__caption-body",
  "caption-body-faded": "StoryViewer-module-scss-module__D02-Pq__caption-body-faded",
  "caption-expanded": "StoryViewer-module-scss-module__D02-Pq__caption-expanded",
  "caption-text": "StoryViewer-module-scss-module__D02-Pq__caption-text",
  "caption-toggle": "StoryViewer-module-scss-module__D02-Pq__caption-toggle",
  "card": "StoryViewer-module-scss-module__D02-Pq__card",
  "fill": "StoryViewer-module-scss-module__D02-Pq__fill",
  "header": "StoryViewer-module-scss-module__D02-Pq__header",
  "header-actions": "StoryViewer-module-scss-module__D02-Pq__header-actions",
  "header-avatar": "StoryViewer-module-scss-module__D02-Pq__header-avatar",
  "header-button": "StoryViewer-module-scss-module__D02-Pq__header-button",
  "header-title": "StoryViewer-module-scss-module__D02-Pq__header-title",
  "loading": "StoryViewer-module-scss-module__D02-Pq__loading",
  "loading-icon": "StoryViewer-module-scss-module__D02-Pq__loading-icon",
  "media": "StoryViewer-module-scss-module__D02-Pq__media",
  "overlay": "StoryViewer-module-scss-module__D02-Pq__overlay",
  "preload": "StoryViewer-module-scss-module__D02-Pq__preload",
  "progress-row": "StoryViewer-module-scss-module__D02-Pq__progress-row",
  "spin": "StoryViewer-module-scss-module__D02-Pq__spin",
  "tap-zone": "StoryViewer-module-scss-module__D02-Pq__tap-zone",
  "tap-zone-next": "StoryViewer-module-scss-module__D02-Pq__tap-zone-next",
  "tap-zone-prev": "StoryViewer-module-scss-module__D02-Pq__tap-zone-prev",
  "track": "StoryViewer-module-scss-module__D02-Pq__track",
});
